import { render, staticRenderFns } from "./TaskKanbanBoard.vue?vue&type=template&id=349dbe6e&scoped=true&"
import script from "./TaskKanbanBoard.vue?vue&type=script&lang=js&"
export * from "./TaskKanbanBoard.vue?vue&type=script&lang=js&"
import style0 from "./TaskKanbanBoard.vue?vue&type=style&index=0&id=349dbe6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349dbe6e",
  null
  
)

export default component.exports